<div class="content-panel">
    <div class="under-maintenance">

        <img id="underMaintenace" alt="under-maintenance" src="assets/images/maintenance-icon.png">
    
        <h4> Under construction</h4>
        <p>This feature is currently under construction.</p>
        <p> Please check back soon.</p>
    </div>
</div>
